import { Box } from '@material-ui/core';
import { AssetType, formatMoney, getAssetDetailsByIdAndType, Loan } from '@nemuru-eng/js-api-client';

import { LoadingValuesWarning } from '@/components/modules/Documentation/components/shared/LoadingValuesWarning';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCache } from '@/hooks/requests/useCache';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';
interface CardConditionsDataProps {
  loan: Loan;
}

export const CardConditionsData = ({ loan }: CardConditionsDataProps) => {
  const { getTextIdTranslation } = useTranslation();
  const { data: assetDetails, loading: assetDetailsLoading } = useCache(getAssetDetailsByIdAndType, {
    assetId: loan.assetReference[0].id,
    assetType: loan.assetReference[0].type,
  });

  if (assetDetailsLoading || !assetDetails || assetDetails.type !== AssetType.CARD) return <LoadingValuesWarning />;

  return (
    <>
      <Box display={'flex'} flexDirection={'column'}>
        <ReadOnlyDataRow labelTextId={'BRAND'} value={assetDetails.brand} />
        <ReadOnlyDataRow
          labelTextId={'PAYMENT_MODE'}
          value={assetDetails.paymentMode ? getTextIdTranslation(assetDetails.paymentMode) : undefined}
        />
        <ReadOnlyDataRow labelTextId={'MONTHLY_STATEMENT_DAY'} value={assetDetails.monthlyStatementDay} />
        {assetDetails.fixedInstalmentAmount && (
          <ReadOnlyDataRow
            labelTextId={'FIXED_INSTALMENT_AMOUNT'}
            value={formatMoney(amountToValueMoneyMapper(assetDetails.fixedInstalmentAmount))}
          />
        )}
        {assetDetails.cardRequestedLimit && (
          <ReadOnlyDataRow
            labelTextId={'CARD_REQUESTED_LIMIT'}
            value={formatMoney(amountToValueMoneyMapper(assetDetails.cardRequestedLimit))}
          />
        )}
      </Box>
    </>
  );
};
